import Vue from "vue";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
import Vuelidate from "vuelidate";
import DatetimePicker from "vuetify-datetime-picker";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import Multiselect from "vue-multiselect";
import VueSweetalert2 from "vue-sweetalert2";
import JsonCSV from "vue-json-csv";
import VueClipboard from "vue-clipboard2";

import * as components from "./common/components";
import * as mixins from "./common/mixins";

import { DependencyPlugin } from "./dependencies";

import "vue-multiselect/dist/vue-multiselect.min.css";

Vue.config.productionTip = false;

Vue.component("multiselect", Multiselect);
Vue.component("downloadCsv", JsonCSV);

Object.keys(components).forEach(key => {
  Vue.component(key, (components as any)[key]);
});

Object.entries(mixins).forEach(([, mixin]) => {
  Vue.mixin(mixin);
});

Vue.use(DependencyPlugin);
Vue.use(VueSweetalert2);
Vue.use(VueClipboard);
Vue.use(VueMoment, {
  moment
});
Vue.use(Vuelidate);
Vue.use(DatetimePicker);

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount("#app");
